import {Injectable} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {Land} from "../../../models/land/Land";

@Injectable({
  providedIn: 'root'
})
export class EnumHelperService {

  constructor(private translateService: TranslateService) {}

  getGeschlechtOptionList():{id: string, name: any}[] {
    return [{id: null, name: "-"},
      {id: "MAENNLICH", name: this.translateService.instant("STANDARD.GESCHLECHT.MAENNLICH")},
      {id: "WEIBLICH", name: this.translateService.instant("STANDARD.GESCHLECHT.WEIBLICH")},
      {id: "DIVERS", name: this.translateService.instant("STANDARD.GESCHLECHT.DIVERS")}
    ];
  }

  getLandOptionList() {
    return Object.keys(Land).map((name) => {
      return {name, value: Land[name as keyof typeof Land],};
    });
  }

  // standardized to key-value pairs
  getLandOptionListKV() {
    return Object.keys(Land).map((name) => {
      return {key: name, value: Land[name as keyof typeof Land],};
    });
  }

}

// reverse enum lookup by value
// example call: getEnumKeyByValue(Land, "Deutschland") returns Land.DEUTSCHLAND
export function getEnumKeyByValue<T extends object>(enumObj: T, value: string): string | undefined {
  return Object.keys(enumObj).find(key => enumObj[key as keyof T] === value);
}

